import React from 'react';
import { Button } from 'ui';
import LinkButton from 'components/shared/LinkButton';

const CompletionTimeForm = ({
  loading,
  estimatedMinutesToComplete,
  onUpdateCompletionTime,
  onCompletionTimeChange,
  onAutoCalculateCompletionTime,
}) => (
  <div className="mt-16">
    <form className="d-f ai-c" onSubmit={onUpdateCompletionTime}>
      <input
        id="pathCompletionTime"
        type="number"
        className="NewInput NewInput--white mr-8 pr-0 completionTimeInput"
        min="0.5"
        step="0.5"
        value={estimatedMinutesToComplete}
        max="10000"
        placeholder={t(
          'paths.path_builder.sidebar.completion_time.placeholder',
        )}
        onChange={onCompletionTimeChange}
      />
      <Button disabled={loading} loading={loading} submit primary>
        {t('common.save')}
      </Button>
    </form>

    <div className="mt-8">
      <LinkButton
        className="u-linkBtn td-n"
        onClick={onAutoCalculateCompletionTime}
        disabled={loading}
      >
        {t('paths.path_builder.sidebar.completion_time.auto_calculate_button')}
      </LinkButton>
    </div>
  </div>
);

export default CompletionTimeForm;
